import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=17fca3bc"
import script from "./FormGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormGroup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports